module.exports = __webpack_public_path__ + "static/media/two_directional_boxes.36ea2663.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/two_directional_boxes.svg
// module id = 1401
// module chunks = 0